import axiosInstance from './axiosConfig';
import { reportError } from '../sentry';

const openOverviewPatientForm = async (patientDetails?: {
  personalNumber: string;
  firstName: string;
  lastName: string;
}) => {
  const baseUrl = process.env.FORM_ADMIN_SERVICE_URL;

  if (!baseUrl) {
    reportError(new Error('FORM_ADMIN_SERVICE_URL is not configured'));
    return;
  }

  if (
    !patientDetails ||
    !patientDetails.personalNumber ||
    !patientDetails.firstName ||
    !patientDetails.lastName
  ) {
    reportError(new Error('Patient details missing for the forms overview'));
    return;
  }

  let codeResponse;
  try {
    const response = await axiosInstance.post(`/forms/code`, {
      patientPersonalNumber: patientDetails.personalNumber,
      patientFirstName: patientDetails.firstName,
      patientLastName: patientDetails.lastName,
    });

    codeResponse = response?.data;
  } catch (error) {
    reportError(error, { tags: { area: 'forms_overview_code' } });
    return;
  }

  const code = codeResponse?.result?.code;

  if (!code) {
    reportError(new Error('One-time forms code missing from response'));
    return;
  }

  const url = new URL(`${baseUrl}/form-overview`);
  url.searchParams.append('code', code);

  window.open(url.toString(), '_blank', 'noopener,noreferrer');
};

export default openOverviewPatientForm;
